<div class="dialog-container">
    <div class="page-row-blank">
        <div class="column">
            <div class="card-image-container">
                <img src="{{course.imageUrl}}" alt="logo" />
                <div class="card-price-tag">{{course.price}} CHF</div>
            </div>
            <div class="typo-h1 spacing-top">{{course.title}}</div>
            <div class="label spacing-top">
                <mat-icon>home</mat-icon>
                <div class="body-text-bold">{{ locationInfo() }}</div>
            </div>
            <div class="card-description spacing-top color-900">{{getDescription()}}</div>
        </div>
    </div>
    <div class="actions spacing-top">
        <app-text-button (click)="showBooking()" [text]="'courses.book' | transloco" colorVariant="primary" leadingIcon="check_circle" type="rounded" />
    </div>
</div>
